import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

export async function getShippingInfoByReservation(reservationId: string) {
  return axiosFetch.get(
    `/api/ShippingInfo/getByReservationId/${reservationId}`
  );
}

export async function postShippingInfo<T>(body: T) {
  return axiosFetch.post("/api/ShippingInfo/upsert", body);
}

export async function updateLogisticsFields(body: {
  reservationId: string;
  logisticsStatus?: string;
  logisticsStatusColor?: string;
  logisticsNote?: string;
  logisticsNoteColor?: string;
  outboundCourierOrdered?: boolean;
  outboundCourierCompany?: string;
  outboundTrackingNumber?: string;
  outboundPickupDate?: string | null;
  outboundExpectedDelivery?: string | null;
  inboundCourierOrdered?: boolean;
  inboundCourierCompany?: string;
  inboundTrackingNumber?: string;
  inboundPickupDate?: string | null;
  inboundExpectedDelivery?: string | null;
  deviceReturnedOk?: boolean;
  memoBookSent?: boolean;
}) {
  return axiosFetch.post("/api/ShippingInfo/updateLogisticsFields", body);
}

export async function getLogisticsList(params?: {
  statusFilter?: string;
  statusColorFilter?: string;
  noteColorFilter?: string;
  courierCompanyFilter?: string;
  trackingNumberFilter?: string;
  titleFilter?: string;
  deviceReturnedOkFilter?: boolean;
  memoBookSentFilter?: boolean;
  outboundCourierOrderedFilter?: boolean;
  inboundCourierOrderedFilter?: boolean;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
}) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, String(value));
      }
    });
  }
  const queryString = queryParams.toString();
  return axiosFetch.get(
    `/api/ShippingInfo/logistics${queryString ? `?${queryString}` : ""}`
  );
}

export async function downloadLogisticsExport(params?: {
  dateFrom?: string;
  dateTo?: string;
  search?: string;
  format?: "xlsx";
}) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, String(value));
      }
    });
  }
  if (!queryParams.has("format")) {
    queryParams.append("format", "xlsx");
  }
  return axiosFetch.get(`/api/v1/logistics/export?${queryParams.toString()}`, {
    responseType: "blob",
  });
}
